/// Store for the state of bulk-data-download-panel (what type of data is selected, etc.).

import { defineStore } from "pinia";
import { DATA_TYPES, COST_MODES, RECIPE } from "./constants";

const values = (arr) => arr.map((item) => item.value);
const ensureValid = (current, validChoices) =>
  validChoices.includes(current) ? current : validChoices[0];

export const useBulkDataDownloadStore = defineStore("bulkDataDownload", {
  persist: { storage: sessionStorage },

  state: () => ({
    selectedDataType: DATA_TYPES[0].value,
    selectedMenuFormat: "csv",
    selectedDailyValuesFormat: null,
    expandSubrecipes: true,
    costsMode: RECIPE,
    pdfTitle: null,
  }),

  actions: {
    /// Initialize checks that all settings are still valid, and if any are not,
    /// it falls back to a default picked from current valid choices.
    /// This is to avoid any glitchy/confusing behavior if the user's browser has
    /// settings persisted from before we made a change to the options.
    initialize(dailyValuesOptions) {
      this.selectedDataType = ensureValid(this.selectedDataType, values(DATA_TYPES));
      this.costsMode = ensureValid(this.costsMode, values(COST_MODES));
      this.selectedDailyValuesFormat = ensureValid(
        this.selectedDailyValuesFormat,
        dailyValuesOptions
      );
    },
  },
});
